'use es6';

import PositionedBetaButton from './PositionedBetaButton';
import styled from 'styled-components';
const MinimizedBetaButton = styled(PositionedBetaButton).withConfig({
  displayName: "MinimizedBetaButton",
  componentId: "sc-1lil23n-0"
})(["border-bottom-left-radius:0;border-top-left-radius:0;left:var(--global-nav-vertical-nav-width,0);"]);
export default MinimizedBetaButton;